import { createRootRoute, Outlet } from '@tanstack/react-router';
import { ThemeManager } from '@/features/settings/components/theme-manager';

export const Route = createRootRoute({
  component: () => (
    <>
      <ThemeManager />
      <Outlet />
    </>
  ),
});
